import { colors } from '../../../../../colorVars';

type Props = {
  size: string;
  margin: string;
};

export const UpArrow = ({ size, margin }: Props) => {
  return (
    <svg
      fill={colors.green}
      x="0px"
      y="0px"
      viewBox="0 0 490 490"
      xmlSpace="preserve"
      width={size}
      height={size}
      style={{ margin }}
    >
      <g>
        <path
          d="M0.358,245c0,135.309,109.53,245,244.641,245s244.643-109.691,244.643-245S380.111,0,244.999,0S0.358,109.691,0.358,245z
		      M340.513,313.43H140.618l99.951-187.215L340.513,313.43z"
        />
      </g>
    </svg>
  );
};
